<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Customers | Master</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card card-danger card-outline">
                        <div class="card-header">Daily Collections</div>
                        <div class="card-body overflow-auto">
                            <br />
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Select From:</span
                                            >
                                            <input
                                                type="date"
                                                class="form-control"
                                                v-model="from"
                                                placeholder="Select date"
                                            />
                                        </div>
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Select To:</span
                                            >
                                            <input
                                                type="date"
                                                class="form-control"
                                                v-model="to"
                                                placeholder="Select date"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Search by Branch:</span
                                            >
                                            <v-select
                                                v-model="branch"
                                                class="form-control"
                                                type="text"
                                                label="branch"
                                                :options="branches"
                                                :reduce="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                                name="branch"
                                                placeholder="Select Branch"
                                                :value="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                            ></v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group float-left">
                                            <button
                                                class="btn btn-danger"
                                                @click="getPayments"
                                            >
                                                <i class="fa fa-search"></i>
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br /><br />
                            <div class="col-md-12">
                                <div class="row" align="center">
                                    <div class="col-lg-3 col-6">
                                        <!-- small box -->
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h3>{{ total }}</h3>
                                                <p>Total</p>
                                            </div>
                                            <div class="icon">
                                                <i
                                                    class="ion ion-person-add"
                                                ></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-6">
                                        <!-- small box -->
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h3>{{ voucher }}</h3>
                                                <p>Voucher</p>
                                            </div>
                                            <div class="icon">
                                                <i
                                                    class="ion ion-pie-graph"
                                                ></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-6">
                                        <!-- small box -->
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h3>{{ saadha }}</h3>
                                                <p>Others</p>
                                            </div>
                                            <div class="icon">
                                                <i class="ion ion-bag"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-6">
                                        <!-- small box -->
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h3>{{ billed_total }}</h3>
                                                <p>Billed Total</p>
                                            </div>
                                            <div class="icon">
                                                <i class="ion ion-bag"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <br />
                            </div>

                            <!-- <div class="col-sm-12"> -->
                            <div class="col-sm-12 overflow-auto">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div
                                            class="card card-danger card-outline"
                                        >
                                            <div class="card-header">
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <h5>Payments</h5>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <button
                                                            class="btn btn-primary float-right"
                                                            @click="exportPms"
                                                        >
                                                            <i
                                                                class="fa fa-print"
                                                            ></i>
                                                            Export
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="card-body overflow-auto"
                                            >
                                                <table
                                                    class="table table-striped table-bordered table-hover"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Job No</th>
                                                            <th>Branch</th>
                                                            <th>Amount</th>
                                                            <th>Mode</th>
                                                            <th>Remarks</th>
                                                            <th>
                                                                Transaction ID
                                                            </th>
                                                            <th>Voucher No.</th>
                                                            <th>Bill No.</th>
                                                            <th>Entered By</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            v-for="r in data"
                                                            :key="r.id"
                                                        >
                                                            <td>
                                                                <a
                                                                    :href="
                                                                        '/service-admin/job-profile/' +
                                                                        r.job_id
                                                                    "
                                                                    target="_blank"
                                                                    >{{
                                                                        r.job_no
                                                                    }}</a
                                                                >
                                                            </td>
                                                            <td>
                                                                {{ r.branch }}
                                                            </td>
                                                            <td>
                                                                {{ r.amount }}
                                                            </td>
                                                            <td>
                                                                {{ r.mode }}
                                                            </td>
                                                            <td>
                                                                {{ r.remarks }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    r.transaction_id
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    r.erp_receipt_no
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    r.erp_bill_no
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    r.entered_name
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- </div> -->
                        </div>
                        <div class="card-footer"></div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getBranches();
    },

    data() {
        return {
            from: "",
            to: "",
            total: "",
            voucher: "",
            saadha: "",
            billed_total: "",
            data: [],
            branches: [],
            branch: "",
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getPayments() {
            axios
                .post("/api/getPaymentsAdmin", {
                    from: this.from,
                    to: this.to,
                    branch: this.branch,
                })
                .then((response) => {
                    this.data = response.data.data;
                    this.total = response.data.amount;
                    this.voucher = response.data.voucher_total;
                    this.saadha = response.data.saadha_total;
                    this.billed_total = response.data.billed_total;
                });
        },

        exportPms() {
            axios({
                url: "/api/getPaymentsAdminExport",
                data: { from: this.from, to: this.to, branch: this.branch },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Report Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(response.data, "daily_payments.xlsx");
            });
        },
    },
};
</script>
